"use strict";

var _regeneratorRuntime = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var req = require('tiny_request');

var BotsLongPollUpdatesProvider =
/*#__PURE__*/
function () {
  function BotsLongPollUpdatesProvider(api, groupId) {
    _classCallCheck(this, BotsLongPollUpdatesProvider);

    this.api = api;
    this.groupId = groupId;
    this.init();
  }

  _createClass(BotsLongPollUpdatesProvider, [{
    key: "getUpdates",
    value: function getUpdates(callback) {
      this.updatesCallback = callback;
    }
  }, {
    key: "init",
    value: function init() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var longPollServer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.api.groupsGetLongPollServer({
                  group_id: this.groupId
                });

              case 2:
                longPollServer = _context.sent;
                this.server = longPollServer.server;
                this.key = longPollServer.key;
                this.ts = longPollServer.ts;
                this.poll();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "poll",
    value: function poll() {
      var _this = this;

      req.get({
        url: "".concat(this.server, "?act=a_check&key=").concat(this.key, "&ts=").concat(this.ts, "&wait=25"),
        json: true
      }, function (body, response, err) {
        if (!err && response.statusCode == 200) {
          if (body.failed && (body.failed == 2 || body.failed == 3)) {
            _this.init();

            return;
          }

          _this.ts = body.ts;
          if (_this.updatesCallback) _this.updatesCallback(body.updates);

          _this.poll();

          return;
        }

        _this.poll();
      });
    }
  }]);

  return BotsLongPollUpdatesProvider;
}();

exports.BotsLongPollUpdatesProvider = BotsLongPollUpdatesProvider;